import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Styles from './index.scss'
import ModalConfirmation from './ModalConfirmation'

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalOpen: false,
    }

    this.openModal = this.openModal.bind(this)
    this.requestClose = this.requestClose.bind(this)
    this.confirmCompleteProject = this.confirmCompleteProject.bind(this)
  }

  openModal() {
    this.setState({
      modalOpen: true,
    })
  }

  requestClose() {
    this.setState({
      modalOpen: false,
    })
  }

  confirmCompleteProject() {
    this.setState({
      modalOpen: false,
    })
    this.props.handleCompleteProject()
  }

  getAllManagersName(managers) {
    if (managers) {
      return managers.map(manager => manager.profile.profileId).join(', ')
    }
  }

  render() {
    let buttonAction = 'btn-disabled'
    if (this.props.projectDetail.status === 4) {
      buttonAction = 'btn-active'
    } else if (this.props.projectDetail.status === 5) {
      buttonAction = 'btn-completed'
    }

    let statusApprove = ''
    if (this.props.projectDetail.actionedBy) {
      if (this.props.projectDetail.isApproved) {
        statusApprove = `Approved By ${this.props.projectDetail.actionedBy.firstName}`
      } else {
        statusApprove = `Rejected By ${this.props.projectDetail.actionedBy.firstName}`
      }
    } else if (this.props.projectDetail.actionedBy === null) {
      if (this.props.projectDetail.isApproved) {
        statusApprove = 'Approve By Admin'
      } else if (this.props.projectDetail.isApproved === false) {
        statusApprove = 'Rejected By Admin'
      }
    }

    return (
      <div className={`row margin-bottom-20 ${Styles.header}`}>
        <div className={Styles['header-content']}>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Profile</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              <Link to={`/profiles/${this.props.projectDetail.profileId}`}>
                <a>{this.props.projectDetail.profileId}</a>
              </Link>
            </span>
          </div>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Project Name</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              {this.props.projectDetail.name}
            </span>
          </div>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Brand</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              {this.props.projectDetail.brand}
            </span>
          </div>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Manager</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              {this.props.projectDetail.managers
                ? this.getAllManagersName(this.props.projectDetail.managers)
                : '-'}
            </span>
          </div>
        </div>
        <div className={Styles['header-content']}>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Product Type</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              {this.props.projectDetail.productType.name}
            </span>
          </div>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Service</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              {this.props.projectDetail.service.name}
            </span>
          </div>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Terms of Payment</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              {this.props.projectDetail.termsOfPayment.label}
            </span>
          </div>
        </div>
        <div className={Styles['header-content']}>
          <div className={Styles['detail-info']}>
            <span className={`${Styles.info} ${Styles.label}`}>Status</span>
            <span className={`${Styles.info} ${Styles.value}`}>
              {this.props.projectDetail.statusLabel}
            </span>
          </div>
          <div className={`${Styles['detail-info']} ${Styles.action}`}>
            <span className={`${Styles.info} ${Styles.label}`}>Action</span>
            {this.props.projectDetail.isApproved ||
            this.props.projectDetail.status === 6 ? (
              <button
                className={`${Styles['btn-complete-project']} ${Styles[buttonAction]}`}
                disabled={this.props.projectDetail.status !== 4}
                onClick={this.openModal}
              >
                {this.props.projectDetail.status === 5 ? 'Completed' : 'Complete Project'}
              </button>
            ) : (
              <>
                <button
                  className={`${Styles['btn-action']} ${Styles['btn-approve']}`}
                  onClick={this.props.handleApprovedProject(
                    this.props.projectDetail.id,
                    true
                  )}
                >
                  Approve
                </button>
                <button
                  className={`${Styles['btn-action']} ${Styles['btn-rejection']}`}
                  onClick={this.props.handleApprovedProject(
                    this.props.projectDetail.id,
                    false
                  )}
                >
                  Reject
                </button>
              </>
            )}
          </div>
          <div className={Styles['detail-info-center']}>
            <span className={`${Styles.value}`}>{statusApprove}</span>
          </div>
        </div>
        <ModalConfirmation
          open={this.state.modalOpen}
          requestClose={this.requestClose}
          handleCompleteProject={this.confirmCompleteProject}
        />
      </div>
    )
  }
}

Header.propTypes = {
  projectDetail: PropTypes.shape({
    profileId: PropTypes.string,
    name: PropTypes.string,
    brand: PropTypes.string,
    productType: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    service: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    status: PropTypes.number,
    manager: PropTypes.object,
    statusLabel: PropTypes.string,
    termsOfPayment: PropTypes.shape({
      label: PropTypes.string,
    }).isRequired,
  }).isRequired,
  handleCompleteProject: PropTypes.func.isRequired,
  handleApprovedProject: PropTypes.func.isRequired,
}

export default Header
